// Chalk tallies beside the door (roadmap 28). Display only: the count comes from the server (round.tallies, reveal.tallies);
// the multiplier shown is the streak the next door pays (game/rules.js streakMult).
import { streakMult } from '../game/rules.js';

export const SMEAR_MS = 900;
const num = n => String(+n.toFixed(2));

// "x1.25": what the next door pays at n tallies
export const streakText = n => `x${num(streakMult(n))}`;

// n tallies as groups of five: four strokes, and the fifth strikes through them
export function tallyGroups(n) {
  const groups = [];
  for (let left = Math.max(0, n | 0); left > 0; left -= 5) groups.push({ strokes: Math.min(4, left), struck: left >= 5 });
  return groups;
}

// What the corner shows at a moment. set(n, at) takes effect at `at` (the end of the sum), so the old count stands until then;
// a count that falls to zero from something smears away over SMEAR_MS and leaves a smudge until the next change.
export function createTallies() {
  let from = 0, to = 0, at = 0, held = null;
  return {
    seed(n) { from = to = Math.max(0, n | 0); at = 0; held = null; },
    // held: a demo freezes the smear at that age
    set(n, when, hold = null) { from = to; to = Math.max(0, n | 0); at = when; held = hold; },
    get target() { return to; },
    view(now) {
      if (now < at) return { n: from, smear: null };
      return { n: to, smear: to === 0 && from > 0 ? { n: from, age: held ?? now - at } : null };
    },
  };
}
